<div class="bg-white rounded shadow w-full h-full p-2">
  <slot />
</div>
